import type { VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/ui/style-helpers'

import { SWATCH_HATCH_STRIPE_PX, SWATCH_HATCH_TINT_PERCENT } from './consts'
import { swatchVariants } from './variants'

export type SwatchProps = {
  color?: string
  isHatched?: boolean
  className?: string
} & VariantProps<typeof swatchVariants>

export const Swatch = ({ color, isHatched = false, size, className }: SwatchProps) => (
  <span
    className={cn(swatchVariants({ size }), !color && 'bg-chart-unscored', className)}
    style={color ? swatchStyle(color, isHatched) : undefined}
  />
)

const swatchStyle = (color: string, isHatched: boolean) =>
  isHatched
    ? {
        background: `repeating-linear-gradient(45deg, ${color} 0 ${SWATCH_HATCH_STRIPE_PX}px, color-mix(in srgb, ${color} ${SWATCH_HATCH_TINT_PERCENT}%, transparent) ${SWATCH_HATCH_STRIPE_PX}px ${SWATCH_HATCH_STRIPE_PX * 2}px)`,
      }
    : { backgroundColor: color }
